import './FloatingPanel.less'
import FloatingPanel from './FloatingPanel'

export type { FloatingPanelProps, FloatingPanelRef } from './iFloatingPanel'

export default FloatingPanel
